import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import './videoBlock.module.css';
import VideoModal from '../videoModal/videoModal.component';

const VideoBlock = ({ video }) => {

    const [modalShow, setModalShow] = useState(false);

    return (
        <div className='video-block-wrap pb-3 pb-md-5 pt-3 pt-md-5 bg-light' styleName="video-block-wrap" >
            <div className='' onClick={() => setModalShow(true)}>
                <Row className='align-items-center'>
                    <Col xs={12} md={5}>
                        <h4 className="py-2 mb-4 mb-md-0 text-center text-md-left" styleName="video-title">
                            {video.caption}
                        </h4>
                    </Col>
                    <Col xs={12} md={7}>
                        <Card styleName="video-block">
                            <Card.Img className="video-poster" variant="top" src={"https://img.youtube.com/vi/" + video.youtubeVideoID + "/maxresdefault.jpg"} />
                            { /* <Card.Body>
                                <Card.Link href="#">Card Link</Card.Link>
                                <Card.Link href="#">Another Link</Card.Link>
                            </Card.Body> */}
                        </Card>
                    </Col>
                </Row>
            </div>
            <VideoModal
                videoId={video.youtubeVideoID}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div>
    )
}

export default VideoBlock;